/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Omitted endDate defaults to date.
 * @export
 * @interface TournamentCreateRequest
 */
export interface TournamentCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    city: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentCreateRequest
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentCreateRequest
     */
    longitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof TournamentCreateRequest
     */
    date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TournamentCreateRequest
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    creator?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    matchmakingMode?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    matchOperationsMode?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    matchOperationsRulesetCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentCreateRequest
     */
    publicLiveFeedEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentCreateRequest
     */
    overlayFeedEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TournamentCreateRequest
     */
    overlayThemeCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentCreateRequest
     */
    isInvitationOnly?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentCreateRequest
     */
    invitedEmails?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentCreateRequest
     */
    allowedCountries?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentCreateRequest
     */
    allowPaymentReceiptUpload?: boolean;
}

/**
 * Check if a given object implements the TournamentCreateRequest interface.
 */
export function instanceOfTournamentCreateRequest(value: object): value is TournamentCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    return true;
}

export function TournamentCreateRequestFromJSON(json: any): TournamentCreateRequest {
    return TournamentCreateRequestFromJSONTyped(json, false);
}

export function TournamentCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'location': json['location'],
        'country': json['country'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'creator': json['creator'] == null ? undefined : json['creator'],
        'description': json['description'] == null ? undefined : json['description'],
        'matchmakingMode': json['matchmakingMode'] == null ? undefined : json['matchmakingMode'],
        'matchOperationsMode': json['matchOperationsMode'] == null ? undefined : json['matchOperationsMode'],
        'matchOperationsRulesetCode': json['matchOperationsRulesetCode'] == null ? undefined : json['matchOperationsRulesetCode'],
        'publicLiveFeedEnabled': json['publicLiveFeedEnabled'] == null ? undefined : json['publicLiveFeedEnabled'],
        'overlayFeedEnabled': json['overlayFeedEnabled'] == null ? undefined : json['overlayFeedEnabled'],
        'overlayThemeCode': json['overlayThemeCode'] == null ? undefined : json['overlayThemeCode'],
        'isInvitationOnly': json['isInvitationOnly'] == null ? undefined : json['isInvitationOnly'],
        'invitedEmails': json['invitedEmails'] == null ? undefined : json['invitedEmails'],
        'allowedCountries': json['allowedCountries'] == null ? undefined : json['allowedCountries'],
        'allowPaymentReceiptUpload': json['allowPaymentReceiptUpload'] == null ? undefined : json['allowPaymentReceiptUpload'],
    };
}

export function TournamentCreateRequestToJSON(json: any): TournamentCreateRequest {
    return TournamentCreateRequestToJSONTyped(json, false);
}

export function TournamentCreateRequestToJSONTyped(value?: TournamentCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'location': value['location'],
        'country': value['country'],
        'state': value['state'],
        'city': value['city'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString().substring(0,10),
        'creator': value['creator'],
        'description': value['description'],
        'matchmakingMode': value['matchmakingMode'],
        'matchOperationsMode': value['matchOperationsMode'],
        'matchOperationsRulesetCode': value['matchOperationsRulesetCode'],
        'publicLiveFeedEnabled': value['publicLiveFeedEnabled'],
        'overlayFeedEnabled': value['overlayFeedEnabled'],
        'overlayThemeCode': value['overlayThemeCode'],
        'isInvitationOnly': value['isInvitationOnly'],
        'invitedEmails': value['invitedEmails'],
        'allowedCountries': value['allowedCountries'],
        'allowPaymentReceiptUpload': value['allowPaymentReceiptUpload'],
    };
}

